import { atom } from 'recoil'
import { makeJwtAdapterFactory } from '@/main/adapters'

export const jwtAdapterAtom = atom({
  key: 'jwtAdapter',
  default: makeJwtAdapterFactory()
})
